var $33fe3b0f0884fb7c$exports = {};
$33fe3b0f0884fb7c$exports = {
    "colorSwatchPicker": `Pr\xf3bki kolor\xf3w`,
    "dropzoneLabel": `Strefa upuszczania`,
    "selectPlaceholder": `Wybierz element`,
    "tableResizer": `Zmiana rozmiaru`
};


export {$33fe3b0f0884fb7c$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
